import { BarVerticalComponent } from '@swimlane/ngx-charts';
import { StatisticService } from '../../../shared/services/statistic.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
var ActivityAchievementComponent = (function () {
    function ActivityAchievementComponent(stats, translate) {
        var _this = this;
        this.stats = stats;
        this.translate = translate;
        this.showDay = true;
        this.showWeek = false;
        this.showMonth = false;
        this.data = [
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
        ];
        this.dataWeek = [
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
        ];
        this.dataMonth = [
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
        ];
        this.todayProgress = 0;
        this.weeklyProgress = 0;
        this.week = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
        this.colorScheme = {
            domain: ['#E6A43D'],
        };
        stats.getMyStatistic().then(function (statistics) {
            var todayTimeStamp = moment();
            _this.dataWeek = [];
            for (var day = 0; day < 7; day++) {
                _this.dataWeek.unshift({
                    name: todayTimeStamp.day().toString(),
                    value: statistics[day] || 0,
                });
                todayTimeStamp = todayTimeStamp.subtract(1, 'days');
                if (statistics[day] >= 6) {
                    _this.weeklyProgress++;
                }
            }
            _this.data = _this.dataWeek;
            _this.updateChartDimensions();
            _this.todayProgress = statistics[0];
            todayTimeStamp = moment();
            for (var day = 0; day < 31; day++) {
                if (todayTimeStamp.month() === moment().month() || todayTimeStamp.date() > moment().date()) {
                    _this.dataMonth.unshift({
                        name: todayTimeStamp.date().toString(),
                        value: statistics[day] || 0,
                    });
                    todayTimeStamp = todayTimeStamp.subtract(1, 'days');
                }
            }
            translate.get('GENERAL.daysShort').subscribe(function (res) {
                for (var _i = 0, _a = _this.dataWeek; _i < _a.length; _i++) {
                    var d = _a[_i];
                    d.name = res[d.name];
                }
                if (_this.showWeek) {
                    _this.data = _this.dataWeek;
                }
            });
        });
    }
    ActivityAchievementComponent.prototype.ngAfterViewInit = function () {
        this.updateChartDimensions();
    };
    ActivityAchievementComponent.prototype.resizeBy = function () {
        var _this = this;
        setTimeout(function () {
            _this.updateChartDimensions();
        }, 300);
    };
    ActivityAchievementComponent.prototype.yAxisFormatting = function (value) {
        return value.toString();
    };
    ActivityAchievementComponent.prototype.mapToPercentage = function () {
        var percentage = (this.todayProgress / 6) * 100;
        return Math.min(Math.max(percentage, 0), 100);
    };
    ActivityAchievementComponent.prototype.updateChartDimensions = function () {
        if (this.chart && this.chart.dims) {
            this.chart.barPadding = this.chart.dims.height / (this.data.length - 1) - 30;
            this.chart.update();
        }
        else {
            setTimeout(this.updateChartDimensions, 300);
        }
    };
    ActivityAchievementComponent.prototype.toggleDay = function () {
        this.data = this.dataWeek;
        this.showDay = true;
        this.showWeek = false;
        this.showMonth = false;
    };
    ActivityAchievementComponent.prototype.toggleWeek = function () {
        this.data = this.dataWeek;
        this.showDay = false;
        this.showMonth = false;
        this.showWeek = true;
        this.updateChartDimensions();
    };
    ActivityAchievementComponent.prototype.toggleMonth = function () {
        this.data = this.dataMonth;
        this.showWeek = false;
        this.showDay = false;
        this.showMonth = true;
    };
    return ActivityAchievementComponent;
}());
export { ActivityAchievementComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/activity-achievement/activity-achievement.component.ts.pre-build-optimizer.js